import { render, staticRenderFns } from "./InstructionView.vue?vue&type=template&id=6f715364&"
import script from "./InstructionView.vue?vue&type=script&lang=ts&"
export * from "./InstructionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports